import {
    CREATE_PROVIDER,
    CREATE_PROVIDER_SUCCESS,
    CREATE_PROVIDER_API_ERROR,
    GET_POSTAL_CODE,
    GET_POSTAL_CODE_SUCCESS
} from "./actionTypes"


const initialState = {
    loading: false,
    error: false,
    message: '',
    errors: [],
    id: 0,
    loading: false,
    refresh: false,
    address_city: '',
    address_neighbour: '',
    address:'',
    latitude: '',
    longitude: '',
    uf: '',

    name: '',
    nick: '',
    slug: '',

}

const Provider = (state = initialState, action) => {
    const errorMessage = 'Ocorreu um erro ao tentar enviar os dados.'
    if(action.payload?.data?.message) {
        console.error(action.payload?.data?.message)
    }
    if( action.payload?.error?.message) {
        console.error(action.payload?.error?.message)
    }

    switch (action.type) {
        case CREATE_PROVIDER:
            state = {
                ...state,
                loading: true,
                refresh: false,
                data: action?.payload?.data
            }
            break
        case CREATE_PROVIDER_SUCCESS:
            state = {
                ...state,
                id: action.payload.id,
                refresh: true,
                loading: false,
                data: action?.payload?.data,
                success: action?.payload?.data?.success || false,
                errors: [
                    action.payload?.data?.message ? errorMessage : null,
                    action.payload?.error?.message ? errorMessage : null,
                    ...action?.payload?.data?.errors || []
                ].filter(v => v)
            }
            break
        case CREATE_PROVIDER_API_ERROR:
            state = { 
                ...state, 
                error: action.payload, 
                loading: false ,
                refresh: true,
                success: action?.payload?.data?.success || false,
                errors: [
                    action.payload?.data?.message ? errorMessage : null,
                    action.payload?.error?.message ? errorMessage : null,,
                    ...action?.payload?.data?.errors || []
                ].filter(v => v)
            }
            break
       
        case GET_POSTAL_CODE:
            state = {
                ...state,
                loading: true,
                refresh: false,
            }
            break
        case GET_POSTAL_CODE_SUCCESS:
            state = {
                ...state,
                address_city: action.payload.localidade,
                address_neighbour: action.payload.bairro,
                address:action.payload.logradouro,
                latitude: action.payload.latitude,
                longitude: action.payload.longitude,
                uf: action.payload.uf,
                refresh: false,
                loading: false
            }
            break  

        default:
            state = { ...state }
            break
    }

    state = {...state, formType: 'provider'}
    return state
}
export default Provider

